// removed by extract-text-webpack-plugin
module.exports = {"homeLayers":"_3ebRwoeD1BtCW1u16JqnoB","topSection":"_1A3WXaujUnAXvPUx55E7gq","description":"_1oYURJdicVZ5pCFG5HYkJm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 543
// module chunks = 0